// Csillagtanoda arculati színek (TypeScript / MUI használatra)
export const BRAND = {
  purpleLight: "#C92BB5",
  purple: "#6D1B77",
  purpleDark: "#120A39",
  gradient: "linear-gradient(135deg, #C92BB5, #6D1B77, #120A39)",
  yellow: "#FCC632",
  yellowStar: "#FFCF34",
  onPurple: "#FFFFFF",
  onYellow: "#120A39",
} as const;

// Sötét / világos mód közös színkészlet az oldalakhoz.
// Sötét: a lila átmenetes háttér látszik, kártyák sötétlilák, kiemelés sárga.
// Világos: halvány levendula háttér, fehér kártyák, kiemelés lila.
export const brandPalette = (dark: boolean) => ({
  pageBg: "transparent",
  card: dark ? "rgba(29, 18, 71, 0.88)" : "#FFFFFF",
  cardBorder: dark ? "1px solid rgba(252, 198, 50, 0.28)" : "1px solid rgba(109, 27, 119, 0.18)",
  cardShadow: dark ? "0 8px 24px rgba(0, 0, 0, 0.35)" : "0 6px 18px rgba(109, 27, 119, 0.12)",
  band: dark ? "rgba(18, 10, 57, 0.55)" : "rgba(109, 27, 119, 0.06)",
  heading: dark ? BRAND.yellow : BRAND.purple,
  text: dark ? "rgba(255, 255, 255, 0.9)" : "#2A1A3D",
  muted: dark ? "rgba(255, 255, 255, 0.68)" : "#5E4B70",
  accent: dark ? BRAND.yellow : BRAND.purpleLight,
  btnBg: dark ? BRAND.yellow : BRAND.purple,
  btnText: dark ? BRAND.purpleDark : "#FFFFFF",
  btnHoverBg: dark ? BRAND.yellowStar : BRAND.purpleLight,
});